import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'

import * as defaultVeeRules from 'vee-validate/dist/rules'
import store from '@/store'
import _ from 'lodash'
import Vue from 'vue'
import httpService from '@/core/http-service'
import { sharedText } from '@/core/utils'

function registerRules() {
  const serverValidationRules = _.get(store.getters.clientModel, 'validationRules', {})
  const clientRules = {
    required: { allowFalse: false },
    invalidchars: { validate: (value) => {
      var reg = new RegExp('^[^*]*$')
      return reg.test(value)
    } },
    password: { validate: (value, { other }) => value === other, params: [{ name: 'other', isTarget: true }] },
    passwordPolicy: { validate: (value) => {
      var reg = new RegExp('^(?=.*[A-Z])(?=.*\\d)(?=.*[a-z]).{6,}$')
      return reg.test(value)
    } },
    postalCode: {
      params: ['countryCode', 'regex'],
      validate: (value, { countryCode, regex }) => {
        if (countryCode === '' || countryCode === null || regex === '' || regex === null) {
          return true
        }
        return new RegExp(regex).test(value)
      }
    },
    checked: { validate: (value) => {
      return value || sharedText('validateRequiredField')
    } },
    vatNumber: {
      validate: validateVatNumber,
      message: (fieldName, params, data) => {
        return data
      },
      computesRequired: true
    },
    mobile: {
      params: ['regex'],
      validate: (value, { regex }) => {
        if (regex === '' || regex === null) {
          return true
        }
        return new RegExp(regex).test(value)
      }
    }
  }

  _.forEach(serverValidationRules, (serverRule, name) => {
    const defaultRule = defaultVeeRules[name]
    const mergedRule = _.merge(defaultRule, clientRules[name], serverRule)
    extend(name, mergedRule)
  })
}

function registerVeeValidation() {
  // setInteractionMode('eager')
  registerRules()
  registerComponents()
}

function registerComponents() {
  Vue.component('ValidationObserver', ValidationObserver)
  Vue.component('ValidationProvider', ValidationProvider)
}

async function validateVatNumber(value, params) {
  if (params.length === 0) {
    return true
  }
  // List of VAT formats
  // https://www.avalara.com/vatlive/en/eu-vat-rules/eu-vat-number-registration/eu-vat-number-formats.html
  try {
    const result = await httpService.get('checkout/validateVatNumber', { countryCode: params[0].replace(/^GR/, 'EL'), vatNumber: value.trim().replaceAll('-', '').replace(/^GR/, 'EL') }) // Remove spaces and minus signs in case the user enters it

    console.log(result)

    if (result.data) { return result.data }

    return true
  } catch(error) {
    return false
  }
}

export { registerVeeValidation }
